import i18n from '@/locales'

export const zoneTypes = [
  {
    label: 'PrivateZone',
    value: 'PrivateZone',
    desc: i18n.t('network.text_738'),
  },
  {
    label: 'PublicZone',
    value: 'PublicZone',
    desc: i18n.t('network.text_739'),
  },
]
